// NoContract.jsx (PRO VERSION)
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import "./styles/NoContract.css";

const STAFF_API = "https://okna.co.tz/mrms/Staff.php";
const ITEMS_PER_PAGE = 8;
const ROLES = ["Admin", "Cashier", "Waitress", "Cleaner"];

export default function NoContract() {
  const token = localStorage.getItem("token");

  const [staffList, setStaffList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [editingStaffId, setEditingStaffId] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const [formData, setFormData] = useState({
    full_name: "",
    role: "",
    phone_number: "",
    email: "",
    password: "",
    pin: ""
  });

  useEffect(() => {
    if (!token) {
      Swal.fire("Session Expired", "Login again", "warning");
      return;
    }
    loadStaff();
  }, []);

  const loadStaff = async () => {
    try {
      const res = await fetch(STAFF_API);
      const data = await res.json();
      setStaffList(data.filter(s => s.contract === "no"));
    } catch {
      Swal.fire("Error", "Failed to load staff", "error");
    }
  };

  const handleChange = e =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const resetForm = () => {
    setFormData({ full_name: "", role: "", phone_number: "", email: "", password: "", pin: "" });
    setEditingStaffId(null);
  };

  const handleSubmit = async e => {
    e.preventDefault();

    if (!formData.full_name || !formData.role || !formData.phone_number) {
      return Swal.fire("Missing fields", "Fill required fields", "warning");
    }

    if (formData.role === "Waitress" && !formData.pin) {
      return Swal.fire("PIN required", "Waitress must have PIN", "warning");
    }

    const payload = {
      ...formData,
      contract: "no",
      email: formData.role === "Waitress" ? null : formData.email,
      password: formData.role === "Waitress" ? null : formData.password,
      pin: formData.role === "Waitress" ? formData.pin : null
    };

    try {
      const res = await fetch(
        editingStaffId ? `${STAFF_API}?id=${editingStaffId}` : STAFF_API,
        {
          method: editingStaffId ? "PUT" : "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload)
        }
      );

      const data = await res.json();
      Swal.fire("Success", data.message || "Saved", "success");
      setShowModal(false);
      resetForm();
      loadStaff();
    } catch {
      Swal.fire("Error", "Submit failed", "error");
    }
  };

  const handleDelete = async staff => {
    const confirm = await Swal.fire({
      title: "Delete staff?",
      text: staff.full_name,
      icon: "warning",
      showCancelButton: true
    });
    if (!confirm.isConfirmed) return;

    await fetch(`${STAFF_API}?id=${staff.id}`, { method: "DELETE" });
    loadStaff();
  };

  const toggleActive = async staff => {
    await fetch(`${STAFF_API}?id=${staff.id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        ...staff,
        active: staff.active === "yes" ? "no" : "yes"
      })
    });
    loadStaff();
  };

  const pageData = staffList.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  return (
    <div className="nc-container">
      <div className="nc-header">
        <h2>🚫 Non-Contract Staff</h2>
        <button className="nc-add" onClick={() => { resetForm(); setShowModal(true); }}>
          + Add Staff
        </button>
      </div>

      <div className="nc-card">
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Role</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {pageData.map(staff => (
              <tr key={staff.id}>
                <td>{staff.full_name}</td>
                <td>{staff.role}</td>
                <td>
                  <span className={`nc-badge ${staff.active}`} onClick={() => toggleActive(staff)}>
                    {staff.active}
                  </span>
                </td>
                <td className="nc-actions">
                  <button onClick={() => { setEditingStaffId(staff.id); setFormData(staff); setShowModal(true); }}>✏️</button>
                  <button onClick={() => handleDelete(staff)}>🗑️</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {showModal && (
        <div className="nc-modal">
          <div className="nc-modal-box">
            <h3>{editingStaffId ? "Edit" : "Add"} Staff</h3>
            <form onSubmit={handleSubmit}>
              <input name="full_name" placeholder="Full Name" value={formData.full_name} onChange={handleChange} />
              <select name="role" value={formData.role} onChange={handleChange}>
                <option value="">Select Role</option>
                {ROLES.map(r => <option key={r}>{r}</option>)}
              </select>
              <input name="phone_number" placeholder="Phone" value={formData.phone_number} onChange={handleChange} />

              {formData.role === "Waitress" ? (
                <input name="pin" placeholder="PIN" value={formData.pin} onChange={handleChange} />
              ) : (
                <>
                  <input name="email" placeholder="Email" value={formData.email} onChange={handleChange} />
                  <input type="password" name="password" placeholder="Password" value={formData.password} onChange={handleChange} />
                </>
              )}

              <div className="nc-form-actions">
                <button type="submit">Save</button>
                <button type="button" onClick={() => setShowModal(false)}>Cancel</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

